"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var discardSurfaceActionsOption_1 = require("./actions/discardSurfaceActionsOption");
var saveSurfaceActionsOption_1 = require("./actions/saveSurfaceActionsOption");
var SurfaceActionsFull_1 = require("./components/SurfaceActionsFull");
var isSurfaceActionsOptionDirty_1 = require("./utils/isSurfaceActionsOptionDirty");
var owa_controls_feature_flags_1 = require("owa-controls-feature-flags");
var React = require("react");
var ComposeSurfaceActionsOption = {
    key: 'composeSurfaceActions',
    titleStringKey: 'optionTitle_composeSurfaceActions',
    searchTermsStringKey: 'optionTitle_composeSurfaceActions',
    fullOptionFormSettings: {
        render: function () { return React.createElement(SurfaceActionsFull_1.default, { isCompose: true }); },
        isDirty: isSurfaceActionsOptionDirty_1.default,
        onSave: saveSurfaceActionsOption_1.default,
        onDiscard: discardSurfaceActionsOption_1.default,
    },
    isHidden: function () { return !owa_controls_feature_flags_1.isControlFeatureEnabled('rp-customSurfaceActions'); },
};
exports.default = ComposeSurfaceActionsOption;
//# sourceMappingURL=ComposeSurfaceActionsOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-surface-actions-option/lib/ComposeSurfaceActionsOption.js
// module id = 5237
// module chunks = 2